export class ApiError extends Error {
  status: number;
  payload: unknown;
  constructor(status: number, message: string, payload?: unknown) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

let sessionRedirectScheduled = false;

/** Přesměruje na login, pokud session vypršela uprostřed práce v aplikaci. */
export function redirectToLoginIfSessionExpired(): void {
  if (sessionRedirectScheduled) return;
  if (window.location.pathname === "/login") return;
  sessionRedirectScheduled = true;
  window.location.replace("/login?session=expired");
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    credentials: "include",
    headers: body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return undefined as T;
  const ctype = res.headers.get("content-type") ?? "";
  const data = ctype.includes("application/json") ? await res.json() : await res.text();
  if (!res.ok) {
    const msg = typeof data === "object" && data && "error" in data ? String((data as any).error) : `HTTP ${res.status}`;
    if (res.status === 401) redirectToLoginIfSessionExpired();
    throw new ApiError(res.status, msg, data);
  }
  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>("GET", path),
  post: <T>(path: string, body?: unknown) => request<T>("POST", path, body),
  put: <T>(path: string, body?: unknown) => request<T>("PUT", path, body),
  patch: <T>(path: string, body?: unknown) => request<T>("PATCH", path, body),
  delete: <T>(path: string) => request<T>("DELETE", path),
};
